import { useMemo } from "react";
import useWeb3 from "hooks/useWeb3";
import {
  getERC20,
  getMarketplaceContract,
  getPunkContract,
} from "utils/contractHelpers";
import { accountLessProvider } from "utils/injected";

/**
 * Helper hooks to get specific contracts (by ABI)
 */

export const usePunkContract = () => {
  const web3 = useWeb3();
  return useMemo(() => getPunkContract(web3), [web3]);
};

export const useReadOnlyPunkContract = () => {
  return useMemo(() => getPunkContract(accountLessProvider), []);
};

export const useERC20Contract = () => {
  const web3 = useWeb3();
  return useMemo(() => {
    return !!Number(process.env.REACT_APP_ERC20MODE) ? getERC20(web3) : null;
  }, [web3]);
};

export const useMarketplaceContract = () => {
  const web3 = useWeb3();
  return useMemo(() => getMarketplaceContract(web3), [web3]);
};
